export default {
    IS_SHOW_FIND_PASSWORD: 'IS_SHOW_FIND_PASSWORD',
    IS_SHOW_LOADING: 'IS_SHOW_LOADING',
};
